import { useState } from 'react';
import { useLang } from '@/contexts/LanguageContext';

export default function FlipBook({ className = '' }) {
  const [flipped, setFlipped] = useState(false);
  const { t } = useLang();

  return (
    <div className="flip-book-float">
      <div
        className={`flip-book-scene ${className}`}
        onClick={() => setFlipped(f => !f)}
        onKeyDown={(e) => e.key === 'Enter' && setFlipped(f => !f)}
        role="button"
        tabIndex={0}
        aria-label={flipped ? t('book.tapToFront') : t('book.tapToFlip')}
        data-testid="flip-book"
      >
        <div className={`flip-book-inner ${flipped ? 'flipped' : ''}`}>
          {/* Front Cover */}
          <div className="flip-book-face flip-book-front">
            <img
              src="/images/book-front-cover.png"
              alt="Center of Gravity — Front Cover"
              className="w-full h-full object-cover"
              draggable={false}
            />
          </div>
          {/* Spine — right face of the solid book (Arabic books open right-to-left) */}
          <div className="flip-book-spine" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/book-spine.png)` }} />
          {/* Page fore-edge — left face */}
          <div className="flip-book-pages" />
          {/* Page top edge */}
          <div className="flip-book-pages-top" />
          {/* Back Cover */}
          <div className="flip-book-face flip-book-back">
            <img
              src="/images/book-back-cover.png"
              alt="Center of Gravity — Back Cover"
              className="w-full h-full object-cover"
              draggable={false}
            />
          </div>
        </div>
        <p className="text-center text-text-muted/40 text-xs font-body mt-6 select-none flip-book-hint">
          {flipped ? t('book.tapToFront') : t('book.tapToFlip')}
        </p>
      </div>
    </div>
  );
}
